import { chooseObj, inputObj, pickerObj } from "utils/getObjs";

const basicInformation = [
  inputObj('姓名', 'username', true, true),
  inputObj('证件号码', 'identification', true, true),
  inputObj('性别', 'gender', true, true),
  inputObj('年龄', 'age', true, true),
  // inputObj('手机号码', 'mobilePhone', true),
  // {
  //   infoType: 'verificationCode',
  //   postName: 'mobilePhone',
  //   codePostName: 'authCode',
  //   label: '手机号码',
  //   codeLabel: '验证码',
  //   message: '请输入联系手机',
  //   codeMessage: '请输入验证码',
  //   required: true,
  //   disabled: false,
  //   time: 180,
  // },
  // pickerObj('户口性质', 'registration', true),
  //暂时把户籍性质写死为城镇和农村类型
  pickerObj('人员类别', 'personType', true),
  {
    ...chooseObj('户口性质', 'registration', true),
    option: [[
      { label: '城镇', value: 10 },
      { label: '农村', value: 20 },
    ]]
  },
  pickerObj('户籍地址', 'permanent', true, true, 20),
  inputObj('户籍详细地址', 'reDetail', true),
  pickerObj('常住地址', 'address', true, true),
  inputObj('常住详细地址', 'detail', true),
  {
    ...chooseObj('就业困难人员认定地', 'affirmation', true),
    option: [[
      { label: '户籍地', value: 1 },
      { label: '常住地', value: 0 },
    ]]
  },
  // 资料上传
  {
    ...inputObj('户口簿首页', 'FHousehold', true),
    type: 'fileForm',
    key: 'onlyOne'
  },
  {
    ...inputObj('户口簿内申请人本人的页面', 'FApplicantPage', true),
    type: 'fileForm',
    key: 'onlyOne'
  },
  {
    ...inputObj('其它相关佐证材料（多附件）', 'FOtherDocuments', false),
    type: 'fileForm',
  },
];

export const affirmEmployPage1 = [
  { title: '基本信息', arr: basicInformation },
]
